import {gsap} from "gsap";

window.addEventListener("DOMContentLoaded", () => {

});